import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import AssignmentIcon from "@material-ui/icons/Assignment";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import BlockIcon from "@material-ui/icons/Block";
import DraftsIcon from "@material-ui/icons/Drafts";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import FlagIcon from "@material-ui/icons/Flag";
import HistoryIcon from "@material-ui/icons/History";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import ListIcon from "@material-ui/icons/List";
import PeopleIcon from "@material-ui/icons/People";
import PersonIcon from "@material-ui/icons/Person";
import PieChartIcon from "@material-ui/icons/PieChart";
import RateReviewIcon from "@material-ui/icons/RateReview";
import ReorderIcon from "@material-ui/icons/Reorder";
import SearchIcon from "@material-ui/icons/Search";
import SpellcheckIcon from "@material-ui/icons/Spellcheck";
import ViewListIcon from "@material-ui/icons/ViewList";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAppContext } from "../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../controller/article/ArticleController";
import LabelsContext from "../../../lang/LabelsContext";
import { handleErrorMessage, isUserAssociateEditor, useEffectOnce } from "../../../utils/Utils";
import EnumGroup from "../../../utils/enum/EnumGroup";
import EnumReviewStatus from "../../../utils/enum/EnumReviewStatus";
import useStyles from "./MenuStyle";

const REVIEWER = [EnumGroup.REVIEWER, EnumGroup.EDITOR, EnumGroup.ASSISTANT, EnumGroup.ASSOCIATE_EDITOR];

const EDITOR = [EnumGroup.EDITOR, EnumGroup.ASSISTANT];

const ASSOCIATE_EDITOR = [EnumGroup.EDITOR, EnumGroup.ASSISTANT, EnumGroup.ASSOCIATE_EDITOR];

export default function Menu() {
  const { authData, showMessage, refreshSideMenu } = useAppContext();

  const { axiosGetMyArticle }: ArticleControllerType = ArticleController();

  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const { Labels } = LabelsContext();
  const history = useHistory();
  const location = useLocation();

  const [menuSelected, setMenuSelected] = useState<string>("");
  const [draftNumber, setDraftNumber] = useState<number>(0);
  const [viewNumber, setViewNumber] = useState<number>(0);
  const [actionNeededNumber, setActionNeededNumber] = useState<number>(0);

  useEffect(() => {
    const { pathname } = location;
    setMenuSelected(pathname);
    if (pathname.startsWith("/manuscript/submit") || pathname.startsWith("/manuscript/view")) {
      checkCountNumbers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    checkCountNumbers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshSideMenu]);

  useEffectOnce(() => {
    checkCountNumbers();
  });

  const checkCountNumbers = () => {
    axiosGetMyArticle()
      .then((result: any) => {
        setDraftNumber(result.data.filter((a: any) => a.status === EnumReviewStatus.DRAFT).length);
        setViewNumber(
          result.data.filter(
            (a: any) =>
              ![
                EnumReviewStatus.DRAFT,
                EnumReviewStatus.MINOR_REVISION,
                EnumReviewStatus.MAJOR_REVISION,
                EnumReviewStatus.CORRECTION,
              ].includes(a.status)
          ).length
        );
        setActionNeededNumber(
          result.data.filter((a: any) =>
            [EnumReviewStatus.MINOR_REVISION, EnumReviewStatus.MAJOR_REVISION, EnumReviewStatus.CORRECTION].includes(
              a.status
            )
          ).length
        );
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const handleClick = () => {
    setOpen(!open);
  };

  const menuList = [
    {
      title: Labels.REVIEWER,
      group: REVIEWER,
      item: [
        {
          title: Labels.REVIEW_HISTORY,
          icon: <HistoryIcon />,
          path: "/reviewHistory",
        },
        {
          title: Labels.TO_DO_LIST,
          icon: <ListIcon />,
          path: "/reviewerToDoList",
        },
      ],
    },
    {
      title: Labels.EDITOR,
      group: EDITOR,
      item: [
        {
          title: Labels.TO_DO_LIST,
          icon: <ListIcon />,
          path: "/toDoList",
        },
        {
          title: Labels.ALL_MANUSCRIPT,
          icon: <ViewListIcon />,
          path: "/manuscript/all",
        },
        // {
        //   title: Labels.ARCHIVE,
        //   icon: <ArchiveIcon />,
        //   path: "/manuscript/all",
        // },
        {
          title: Labels.ALL_REVIEWERS,
          icon: <RateReviewIcon />,
          path: "/allReviewers",
        },
        {
          title: Labels.KEYWORDS,
          icon: <FlagIcon />,
          path: "/keywords",
        },
        {
          title: Labels.USERS,
          icon: <PeopleIcon />,
          path: "/users",
        },
        {
          title: Labels.REVIEWERS_STATISTICS,
          icon: <EqualizerIcon />,
          path: "/reviewersStatistics",
        },
        {
          title: Labels.ASSOCIATE_STATISTICS,
          icon: <PieChartIcon />,
          path: "/associateStatistics",
        },
      ],
    },
    {
      title:
        authData?.user.group.group === EnumGroup.ASSOCIATE_EDITOR
          ? Labels.TO_ASSOCIATE_EDITOR
          : Labels.ASSISTANT_EDITOR,
      group: ASSOCIATE_EDITOR,
      item: [
        {
          title: Labels.TO_DO_LIST,
          icon: <ListIcon />,
          path: isUserAssociateEditor(authData) ? "/toDoList" : "/assitantEditorList",
        },
        authData?.user.group.group === EnumGroup.ASSOCIATE_EDITOR && {
          title: Labels.USERS,
          icon: <PeopleIcon />,
          path: "/users",
        },
        authData?.user.group.group === EnumGroup.ASSOCIATE_EDITOR && {
          title: Labels.KEYWORDS,
          icon: <FlagIcon />,
          path: "/keywords",
        },
        authData?.user.group.group === EnumGroup.ASSOCIATE_EDITOR && {
          title: Labels.MY_MANUSCRIPT,
          icon: <ViewListIcon />,
          path: "/associate/myArticle",
        },
        authData?.user.group.group === EnumGroup.ASSOCIATE_EDITOR && {
          title: Labels.REVIEWERS_STATISTICS,
          icon: <EqualizerIcon />,
          path: "/reviewersStatistics",
        },
        // {
        //   title: Labels.ACCEPTED_MANUSCRIPTS,
        //   icon: <CheckCircleIcon />,
        //   path: "/manuscript/all",
        // },
        {
          title: Labels.SEARCH_MANUSCRIPTS,
          icon: <SearchIcon />,
          path: "/searchManuscripts",
        },
        {
          title: Labels.BLACKLIST_AUTHORS,
          icon: <BlockIcon />,
          path: "/blacklist",
        },
        {
          title: Labels.ALL_ASSOCIATE_EDITORS,
          icon: <SpellcheckIcon />,
          path: "/associateEditors",
        },
        {
          title: Labels.TICKETS,
          icon: <HistoryIcon />,
          path: "/ticketsReview",
        },
      ],
    },
  ];

  return (
    <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root}>
      <List
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            {Labels.AUTHOR}
          </ListSubheader>
        }
      >
        <ListItem button className={classes.padding} onClick={handleClick}>
          <ListItemIcon className={classes.icon}>
            <ReorderIcon />
          </ListItemIcon>
          <ListItemText primary={Labels.MANUSCRIPTS} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              className={[
                classes.nested,
                menuSelected.includes("/manuscript/revision") ? classes.listSelected : "",
              ].join(" ")}
              onClick={(e) => {
                setMenuSelected("/manuscript/revision");
                history.push("/manuscript/revision");
              }}
            >
              <ListItemIcon
                className={[
                  classes.icon,
                  menuSelected.includes("/manuscript/revision") ? classes.listIconSelected : "",
                ].join(" ")}
              >
                <AssignmentTurnedInIcon />
              </ListItemIcon>
              <ListItemText primary={`Action needed (${actionNeededNumber})`} />
            </ListItem>
          </List>
        </Collapse>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              className={[classes.nested, menuSelected.includes("/manuscript/view") ? classes.listSelected : ""].join(
                " "
              )}
              onClick={(e) => {
                setMenuSelected("/manuscript/view");
                history.push("/manuscript/view");
              }}
            >
              <ListItemIcon
                className={[
                  classes.icon,
                  menuSelected.includes("/manuscript/view") ? classes.listIconSelected : "",
                ].join(" ")}
              >
                <ViewListIcon />
              </ListItemIcon>
              <ListItemText primary={`${Labels.VIEW} (${viewNumber})`} />
            </ListItem>
          </List>
        </Collapse>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              className={[
                classes.icon,
                classes.nested,
                menuSelected.includes("/manuscript/draft") ? classes.listSelected : "",
              ].join(" ")}
              onClick={(e) => {
                setMenuSelected("/manuscript/draft");
                history.push("/manuscript/draft");
              }}
            >
              <ListItemIcon
                className={[
                  classes.icon,
                  menuSelected.includes("/manuscript/draft") ? classes.listIconSelected : "",
                ].join(" ")}
              >
                <InsertDriveFileIcon />
              </ListItemIcon>
              <ListItemText primary={`${Labels.DRAFT} (${draftNumber})`} />
            </ListItem>
          </List>
        </Collapse>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              className={[
                classes.nested,
                classes.icon,
                menuSelected.includes("/manuscript/submit") ? classes.listSelected : "",
              ].join(" ")}
              onClick={(e) => {
                setMenuSelected("/manuscript/submit");
                history.push("/manuscript/submit");
              }}
            >
              <ListItemIcon
                className={[
                  classes.icon,
                  menuSelected.includes("/manuscript/submit") ? classes.listIconSelected : "",
                ].join(" ")}
              >
                <DraftsIcon />
              </ListItemIcon>
              <ListItemText primary={Labels.SUBMIT} />
            </ListItem>
          </List>
        </Collapse>
        <ListItem
          button
          className={[classes.padding, menuSelected.includes("/tickets") ? classes.listSelected : ""].join(" ")}
          onClick={(e) => {
            setMenuSelected("/tickets");
            history.push("/tickets");
          }}
        >
          <ListItemIcon
            className={[classes.icon, menuSelected.includes("/tickets") ? classes.listIconSelected : ""].join(" ")}
          >
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary={Labels.TICKETS} />
        </ListItem>
        <ListItem
          button
          className={[classes.padding, menuSelected.includes("/profile") ? classes.listSelected : ""].join(" ")}
          onClick={(e) => {
            setMenuSelected("/profile");
            history.push("/profile");
          }}
        >
          <ListItemIcon
            className={[classes.icon, menuSelected.includes("/profile") ? classes.listIconSelected : ""].join(" ")}
          >
            <PersonIcon />
          </ListItemIcon>
          <ListItemText primary={Labels.PROFILE} />
        </ListItem>
      </List>
      <Divider />

      {menuList.map((menu: any, index: number) => {
        if (!menu.group.includes(authData?.user.group.group)) {
          return null;
        }
        return (
          <List
            key={index}
            subheader={
              <ListSubheader component="div" id="nested-list-subheader">
                {menu.title}
              </ListSubheader>
            }
          >
            {menu.item.map((item: any, indexItem: number) => {
              if (!item) {
                return null;
              }

              return (
                <ListItem
                  key={indexItem}
                  button
                  className={[classes.padding, menuSelected.includes(item.path) ? classes.listSelected : ""].join(" ")}
                  onClick={(e) => {
                    setMenuSelected(item.path);
                    history.push(item.path);
                  }}
                >
                  <ListItemIcon
                    className={[classes.icon, menuSelected.includes(item.path) ? classes.listIconSelected : ""].join(
                      " "
                    )}
                  >
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.title} />
                </ListItem>
              );
            })}
          </List>
        );
      })}
    </List>
  );
}
